export enum FileType {
  FILE = 'FILE',

  RESTRICTED_FILE = 'RESTRICTED_FILE',
}
